var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "main",
    { staticClass: "debug-tool" },
    [
      _c(
        "button",
        {
          staticClass: "button is-small is-outlined",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              _vm.isPanelExpanded = !_vm.isPanelExpanded
            },
          },
        },
        [
          !_vm.isPanelExpanded
            ? [
                _c("bulma-icon", {
                  attrs: { name: "fas fa-expand-arrows-alt" },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$pgettext("core.debug", "Open debug panel"))
                  ),
                ]),
              ]
            : [
                _c("bulma-icon", { attrs: { name: "fas fa-compress" } }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$pgettext("core.debug", "Close debug panel"))
                  ),
                ]),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "panel" },
          on: {
            "after-enter": function ($event) {
              _vm.isFullyExpanded = true
            },
            "after-leave": function ($event) {
              _vm.isFullyExpanded = false
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isPanelExpanded,
                  expression: "isPanelExpanded",
                },
              ],
              ref: "panel",
              staticClass: "debug-panel",
            },
            [
              _c(
                "div",
                { ref: "resizeHandle", staticClass: "panel-resize-handle" },
                [_vm._v("⋮")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "panel-close button is-small is-icon",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.isPanelExpanded = false
                    },
                  },
                },
                [_c("icon", { attrs: { name: "fas fa-times" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-header panel-section-tabs" },
                _vm._l(_vm.tabs, function (tab) {
                  return _c(
                    "a",
                    {
                      key: tab.id,
                      staticClass: "tab-header",
                      class: { "is-active": _vm.activeTab == tab.id },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = tab.id
                        },
                      },
                    },
                    [
                      _c("bulma-icon", { attrs: { name: tab.icon } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(tab.title) +
                            "\n                    "
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "panel-content" } }, [
                _vm.isPanelExpanded && _vm.isFullyExpanded
                  ? _c(
                      "div",
                      { staticClass: "panel-content" },
                      [
                        _vm.activeTab == "queries"
                          ? _c("query-browser", {
                              attrs: {
                                endpoint: _vm.queriesEndpoint,
                                requestId: _vm.requestId,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }